import React from 'react';
import { noop } from 'lodash-es';
import { CopyToClipboard } from '@marvelapp/ui-internal';
import { Box, Tooltip, Flex, Icon, IconButton, PinTR } from '@marvelapp/ui';
import { LINK_ICON } from '@marvelapp/theme';
import Minus from '../icons/Minus';
import Plus from '../icons/Plus';
export default function Zoom(_a) {
    var _b = _a.decrementZoom, decrementZoom = _b === void 0 ? noop : _b, _c = _a.incrementZoom, incrementZoom = _c === void 0 ? noop : _c, zoom = _a.zoom, fitZoom = _a.fitZoom;
    var copyIcon = (React.createElement(Icon, { display: "block", height: 24, paths: LINK_ICON, width: 24 }));
    var urlToCopy = window.location.href;
    return (React.createElement(PinTR, { display: "flex", padding: 3 },
        React.createElement(Flex, { alignItems: "center", bg: "white", borderRadius: 2, boxShadow: "button.ghost", py: 1 },
            React.createElement(Box, { px: 1 },
                React.createElement(IconButton, { hoverBg: "white", onClick: decrementZoom },
                    React.createElement(Minus, null))),
            React.createElement(Box, { borderLeft: "1px solid", borderRight: "1px solid", 
                // eslint-disable-next-line
                borderColor: "smoke", px: 1 },
                React.createElement(IconButton, { fontSize: 2, fontWeight: 500, hoverBg: "white", onClick: fitZoom },
                    zoom,
                    "%")),
            React.createElement(Box, { px: 1 },
                React.createElement(IconButton, { hoverBg: "white", onClick: incrementZoom },
                    React.createElement(Plus, null)))),
        React.createElement(Tooltip, { content: "Copy handoff link", position: "bottom" },
            React.createElement(CopyToClipboard, { alignItems: "center", bg: "white", borderRadius: 2, boxShadow: "button.ghost", btnText: copyIcon, display: "flex", height: 34, hoverBg: "white", iconColor: "slate", justifyContent: "center", marginLeft: 2, px: 0, text: urlToCopy, transitionType: "icon", width: 34 }))));
}
